import React from 'react';
import { makeClassName } from '@siteless/util';

const ChevronDownIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
    className={makeClassName('ChevronDownIcon', className)}
  >
    <path
      d="M12,16c-0.3,0-0.5-0.1-0.7-0.3l-6-6c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5.3,5.3l5.3-5.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4
	l-6,6C12.5,15.9,12.3,16,12,16z"
    />
  </svg>
);

export default ChevronDownIcon;
